import React, { Fragment } from 'react';
import { useEffect, useState } from 'react';
import HistoriesContent from '../../components/account/HistoriesContent';
import MoneyDetailsContent from '../../components/account/MoneyDetailsContent';
import ChangeUserPwd from '../../components/account/ChangeUserPwd';
import ChangeUserInfo from '../../components/account/ChangeUserInfo';

import NavLink from 'react-router-dom/NavLink';
import { Route, Switch } from 'react-router-dom';
import PointDetailsContent from '../../components/account/PointDetailsContent';
import PointHistoryContent from '../../components/account/PointHistoryContent';
const MyPage = (props) => {

      const { match } = props;
    //   console.log(props)
    return (
      <Fragment>
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">마이페이지</div>
                </div>
            </div>
            <div className="contents_wrap">
                <div className="contents_box">
                    <div className="con_box00">
                        <div className="tab_wrap">
                        <ul>
                            <NavLink className="tab" activeClassName="tabon" to={`${match.url}/history`}>베팅내역</NavLink>
                            <NavLink className="tab" activeClassName="tabon" to={`${match.url}/depositHistory`}>충/환전내역</NavLink>
                            <NavLink className="tab" activeClassName="tabon" to={`${match.url}/pointExchangeHistory`}>포인트전환내역</NavLink>
                            <NavLink className="tab" activeClassName="tabon" to={`${match.url}/pointHistory`}>포인트내역</NavLink>
                            <NavLink className="tab" activeClassName="tabon" to={`${match.url}/setting`}>비밀번호수정</NavLink>
                            <NavLink className="tab" activeClassName="tabon" to={`${match.url}/userinfo_setting`}>회원정보수정</NavLink>
                        </ul>
                        </div>		
                    </div>
                    <Switch>
                        <Route path={`${match.url}/history`} component={HistoriesContent}/>
                        <Route path={`${match.url}/depositHistory`} component={MoneyDetailsContent}/>
                        <Route path={`${match.url}/pointExchangeHistory`} component={PointDetailsContent}/>
                        <Route path={`${match.url}/pointHistory`} component={PointHistoryContent}/>
                        <Route path={`${match.url}/setting`} component={ChangeUserPwd}/>
                        <Route path={`${match.url}/userinfo_setting`} component={ChangeUserInfo}/>
                    </Switch>
 
                </div>
            </div>
            
            
            
      </Fragment>
    );
};

export default MyPage;


// WEBPACK FOOTER //
// ./src/containers/Account/MyPage.js